const LANDING_PAGE_HOST_SELECTOR = '[data-webflow-component="landing-page"]';
const LANDING_PAGE_HOST_ID = "landing-page";

export function findLandingPageHost(): Element | null {
	if (typeof document === "undefined") {
		return null;
	}

	const marked = document.querySelector(LANDING_PAGE_HOST_SELECTOR);
	if (marked) {
		return marked.closest("[data-props]") ?? marked;
	}

	return document.getElementById(LANDING_PAGE_HOST_ID);
}

export function readLandingHostProps(): Record<string, unknown> | undefined {
	const raw = findLandingPageHost()?.getAttribute("data-props");
	if (!raw) {
		return undefined;
	}

	try {
		const parsed: unknown = JSON.parse(raw);
		if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
			return undefined;
		}
		return parsed as Record<string, unknown>;
	} catch {
		return undefined;
	}
}

export function readHostString(value: unknown): string | undefined {
	if (typeof value !== "string") {
		return undefined;
	}

	const trimmed = value.trim();
	return trimmed === "" ? undefined : trimmed;
}
